import * as firebase from 'firebase/app';
import * as storage from 'firebase/storage';
import * as db from 'firebase/database';
import * as auth from 'firebase/auth';

const config = {
    apiKey: "AIzaSyCAG6uoc1CDEWmdfQ_yBNMvjnfz6MnzkEE",
    authDomain: "durex-quiz-11996.firebaseapp.com",
    //authDomain: "loveuniversity.rs",
    databaseURL: "https://durex-quiz-11996.firebaseio.com",
    projectId: "durex-quiz-11996",
    storageBucket: "durex-quiz-11996.appspot.com",
    messagingSenderId: "655025518188"
}
firebase.initializeApp(config);

//const storage = firebase.storage();
/*
const fire = firebase;
const storage = firebase.storage();
const db = fire.database();
const auth = fire.auth();
*/

export {
    firebase,
    auth,
    config,
    storage,
    db,
}


// WEBPACK FOOTER //
// ./src/config/firebase.js